// @ts-nocheck
import { normalizePaymentCurrency as currencyCode } from './paymentDisplay';

export const getPaymentTransactionId = (value) => {
  if (
    (typeof value !== 'number' && typeof value !== 'string') ||
    !/^[1-9]\d*$/.test(String(value))
  )
    return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
};

export const getSavedPaymentAmounts = (
  transaction,
  transactionId,
  bookingId
) => {
  if (
    !transaction ||
    transactionId == null ||
    getPaymentTransactionId(transaction.transactionid) !== transactionId ||
    Number(transaction.bookingid) !== Number(bookingId)
  )
    return null;
  const operatorCurrency = currencyCode(transaction.currency?.currencycode);
  if (
    !operatorCurrency ||
    transaction.amount == null ||
    !Number.isFinite(Number(transaction.amount))
  )
    return null;
  if (!transaction.chargecurrency)
    return {
      amount: Number(transaction.amount),
      currency: operatorCurrency,
      operatorCurrency
    };
  const chargeCurrency = currencyCode(transaction.chargecurrency);
  if (
    transaction.status !== 'succeeded' ||
    !chargeCurrency ||
    transaction.chargeamount == null ||
    transaction.amountappliedtobalance == null ||
    !Number.isFinite(Number(transaction.chargeamount)) ||
    Number(transaction.chargeamount) <= 0 ||
    !Number.isFinite(Number(transaction.amountappliedtobalance)) ||
    Number(transaction.amountappliedtobalance) <= 0
  )
    return null;
  return {
    amount: Number(transaction.chargeamount),
    currency: chargeCurrency,
    operatorCurrency,
    appliedAmount: Number(transaction.amountappliedtobalance)
  };
};
